import messageHandler from './messageHandler';

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

function initFrame() {

  let scripts = document.querySelectorAll('.rv-rentals-widget:not(.initialized)');

  if (scripts.length === 0) {
    return;
  }

  for(let i = 0; i < scripts.length; i++) {
    scripts[i].classList.add("initialized")
  }

  for(let i = 0; i < scripts.length; i++) {
    
    const iframeNumber = getRandomInt(1, 100000)

    const scriptSource = scripts[i].src;
    const iframe = document.createElement('iframe');
  
    iframe.src = scriptSource.replace('widget.min.js', 'widget.html');
    iframe.className = "white-label-owner-iframe"
    iframe.id = `white-label-owner-iframe-${iframeNumber}`
    iframe.frameborder = "0"
    iframe.style.border = "0"
    iframe.scrolling = "no"
    iframe.width="100%"
    iframe.style.height = '0px'
    iframe.title = "White label owner widget"

    scripts[i].parentNode.insertBefore(iframe, scripts[i]);

    const spinner = scripts[i].parentNode.querySelector(".white-label-widget-spinner");

    if (spinner) {
      spinner.id = `spinner-${iframeNumber}`
    }
    window.addEventListener('message', messageHandler(iframe, scripts[i], iframeNumber));
  }

}

initFrame();
